import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import StepContainer from './StepContainer';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Button from 'components/buttons/Button';
import RadioButton from 'components/CustomInputs/RadioButton';
import Preapproval from 'containers/Preapproval';
import Preference from 'containers/Preference';
import { useDidUpdateEffect } from 'hooks/useDidUpdateEffect';

const content = {
	en: {
		title: 'Where in the process are you?',
		researching: 'I’m just researching',
		visiting: 'I’m visiting houses',
		offers: 'I’m making offers',
		signed: 'I have signed purchase contract',
		previous: 'Previous',
		next: 'Next'
	},
	id: {
		title: 'Ada di tahap mana Anda sekarang?',
		researching: 'Baru mulai cari tahu',
		visiting: 'Mulai mengunjungi rumah',
		offers: 'Sudah melakukan penawaran',
		signed: 'Sudah menandatangani kontrak',
		previous: 'Kembali',
		next: 'Lanjut'
	}
};

const propTypes = {
	toNextPage: PropTypes.func,
	toPrevPage: PropTypes.func,
	validationSchema: PropTypes.object
};

const Process = props => {
	const { toNextPage, toPrevPage, validationSchema } = props;

	const [isUpdated, setIsUpdated] = useState(false);

	const { register, handleSubmit, setValue } = useForm({
		resolver: yupResolver(validationSchema)
	});

	const { state: { process }, setProcess } = Preapproval.useContainer();

	const { state: { languageCode } } = Preference.useContainer();
	const translation = languageCode === 'en' ? content.en : content.id;

	useEffect(() => {
		if (process) {
			setValue('process', process);
		} else {
			setValue('process', `researching`);
		}
	}, []);

	useDidUpdateEffect(() => {
		toNextPage();
	}, [isUpdated]);

	const onSubmit = data => {
		setProcess(data.process);
		setIsUpdated(true);
	};

	const handlePrev = () => {
		toPrevPage();
	};

	return (
		<div className="process-preapproval">
			<div className="title">{translation.title}</div>
			<form onSubmit={handleSubmit(onSubmit)}>
				<div className="custom-radio-container">
					<RadioButton id="one" label={translation.researching} name="process" ref={register} type="radio" value="researching" />
					<RadioButton id="two" label={translation.visiting} name="process" ref={register} type="radio" value="visiting" />
					<RadioButton id="three" label={translation.offers} name="process" ref={register} type="radio" value="offers" />
					<RadioButton id="four" label={translation.signed} name="process" ref={register} type="radio" value="signed" />
				</div>
				<div className="buttons">
					<Button onClick={handlePrev} type="button" variant="outlined">
						{translation.previous}
					</Button>
					<Button type="submit" variant="contained">
						{translation.next}
					</Button>
				</div>
			</form>
		</div>
	);
};

Process.propTypes = propTypes;
export default StepContainer(Process);
